import { cn } from '@/frontend/lib/utils'

import type { FieldLayoutProps } from './form-layout-context'

/**
 * Stacked-fill layout: same as stacked (Label → Description → Control → Error)
 * but with flex-1 + min-w-0 so the field stretches to fill its parent flex row.
 *
 * Useful for building 'mosaic' style forms with varying numbers of form fields per row.
 */
export function StackedFillLayout({
  label,
  description,
  control,
  error,
  className,
}: FieldLayoutProps) {
  return (
    <div className={cn('flex min-w-0 flex-1 flex-col gap-2', className)}>
      {label}
      {control}
      {description}
      {error}
    </div>
  )
}
